@if (viewPhotosAuthorized) {
  <div>
    <p
      class="margin-bottom-30"
      dsContent
      [contentPath]="'claims.photoUpload.claimStatusDescription'"
    ></p>
    @if (!hasPhotos) {
      <p
        class="margin-bottom-30"
        dsContent
        [contentPath]="'claims.photoUpload.claimStatusNoPhotosText'"
      ></p>
    }
    <div class="row">
      <div class="column twelve margin-bottom-10">
        @for (photo of photoList; track photo) {
          <div>
            <div class="full-thumbnail column twelve md-six pad-10 column-height">
              <div class="column five thumbnail-container">
                <img
                  (click)="openPhotoModal(photo)"
                  [attr.src]="photo.url | document | async"
                  class="thumbnail"
                />
              </div>
              <div class="column six pad-left-20 margin-top-20">
                <a (click)="openPhotoModal(photo)" class="font-large">{{ photo.category }}</a>
                <p class="subtext margin-bottom-10">{{ photo.dateCreated }}</p>
                <p class="subtext">{{ photo.description }}</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
<button
  ds-button
  [disabled]="!uploadPhotosAuthorized"
  (click)="addPhotos()"
  dsContent
  [contentPath]="'claims.photoUpload.addPhotosBtn'"
></button>

<ds-modal [id]="modalId" [closeOthers]="true" [maxWidth]="800">
  <div class="row">
    <div class="column twelve">
      <div class="flex justify-center">
        <div class="image-container">
          <img [attr.src]="modalPhoto.url | document | async" class="modal-image" />
        </div>
      </div>
      <div class="margin-left-20 margin-top-20">
        <h3 class="neutral-200-text">{{ modalPhoto.category }}</h3>
        <p class="subtext margin-bottom-10">{{ modalPhoto.dateCreated }}</p>
        <p>{{ modalPhoto.description }}</p>
      </div>
    </div>
  </div>
</ds-modal>
